(() => {
  if (customElements.get('tiles-slider')) {
    return;
  }

  class TilesSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.controlsWrapper = this.closest('section').querySelector('[data-controls-wrapper]');
      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 990
      };
    }

    connectedCallback() {
      this.initSlider();
      this.toggleSliderHandler();
      window.addEventListener('resize', debounce(this.toggleSliderHandler.bind(this), 500));
    }

    initSlider() {
      const sliderList = this.querySelector('.links-with-image__slider');

      if (!sliderList) return;

      const sizeCardSettings = {
        default: {
          slidesPerView: 2.4,
          spaceBetween: 16,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 4.0,
              spaceBetween: 24,
            },
          }
        },
        small: {
          slidesPerView: 1.5,
          spaceBetween: 16,
          breakpoints: {
            [this.breakpoints.desktop]: {
              slidesPerView: 'auto',
              spaceBetween: 24,
            },
          }
        },
      };

      const mainSettings = {
        navigation: {
          nextEl: '.links-with-image__arrow-next',
          prevEl: '.links-with-image__arrow-prev',
        },
        speed: 300,
        ...sizeCardSettings[this.cardsSize]
      };

      this.slider = new Swiper(this.querySelector('.links-with-image__slider'), mainSettings);
    }

    toggleSliderHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSlider(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSlider(destroy) {
      if (destroy) {
        this.slider.destroy(true, true);
      } else {
        this.slider = new Swiper(this.querySelector('.links-with-image__slider'), this.slider.params);
      }
    }

  }

  customElements.define('tiles-slider', TilesSlider);
})();
